module.exports = __webpack_public_path__ + "img/tss-6.a3ff7c90.jpg";